import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Spinner from "../../utils/Spinner/Spinner";
import React from "react";
import styles from './PaymentAdvice.module.css';

interface PaymentAdviceRetryPaymentDialogProps {
    open: boolean;
    onClose: () => void;
    retryExportStatus: Map<string, string>;
    retryError: boolean;
}

const PaymentAdviceRetryPaymentDialog: React.FC<PaymentAdviceRetryPaymentDialogProps> = ({
                                                                                             open,
                                                                                             onClose,
                                                                                             retryExportStatus,
                                                                                             retryError
                                                                                         }) => {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Retry Payment Advice Export</DialogTitle>
            <DialogContent dividers>
                {retryExportStatus.size > 0 ? (
                    <Box>
                        {retryError &&
                            <div className={styles.errorLabel}>At least one payment advice has not been successfully exported. Please contact
                                adyen.dpa.support@reply.com if problem persists</div>}
                        {Array.from(retryExportStatus.entries()).map(([key, value]) => (
                            <div key={key}>
                                <strong>{key}</strong>: {value}
                            </div>
                        ))}
                    </Box>
                ) : (
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Spinner height={'10vh'}/>
                        <p>Sending retry request...</p>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default PaymentAdviceRetryPaymentDialog;
